import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { TRotation } from '../../components/DocumentViewer/hooks/useDocumentRotation';

interface IScrollPosition {
  pageNumber: number;
  pageOffsetRatio: number;
  zoomLevel: number;
  rotation: TRotation;
}

interface IScrollMemoryState {
  [scrollKey: string]: IScrollPosition | null;
}

interface DocumentViewerScrollState {
  scrollMemoryState: IScrollMemoryState | null;
}

const initialState: DocumentViewerScrollState = {
  scrollMemoryState: null,
};

const documentViewerScrollSlice = createSlice({
  name: 'documentViewerScroll',
  initialState,
  reducers: {
    saveScrollPosition: (
      state,
      action: PayloadAction<{
        scrollKey: string;
        pageNumber: number;
        pageOffsetRatio: number;
        zoomLevel: number;
        rotation: TRotation;
      }>,
    ) => {
      const { scrollKey, pageNumber, pageOffsetRatio, zoomLevel, rotation } = action.payload;
      if (!state.scrollMemoryState) {
        state.scrollMemoryState = {};
      }
      state.scrollMemoryState[scrollKey] = {
        pageNumber,
        pageOffsetRatio,
        zoomLevel,
        rotation,
      };
    },
    clearScrollMemory: (state, action: PayloadAction<string>) => {
      const scrollKey = action.payload;
      if (state.scrollMemoryState) {
        state.scrollMemoryState[scrollKey] = null;
      }
    },
    clearFileScrollMemory: (state, action: PayloadAction<string>) => {
      const fileId = action.payload;
      if (state.scrollMemoryState) {
        const scrollMemory = state.scrollMemoryState;
        const keysToDelete = Object.keys(scrollMemory).filter(key => key.startsWith(fileId));
        keysToDelete.forEach(key => {
          scrollMemory[key] = null;
        });
      }
    },
    resetDocumentViewerScrollSlice: () => initialState,
  },
});

export default documentViewerScrollSlice.reducer;

export const { saveScrollPosition, clearScrollMemory, clearFileScrollMemory, resetDocumentViewerScrollSlice } =
  documentViewerScrollSlice.actions;
